<template>
  <v-row class="mt-1">
    <v-col>
      <template v-for="(email, index) in updated_emailaddresses">
        <v-text-field
            v-if="email.type === email_type"
            :key="index"
            density="default"
            class="reg-normal text-primary"
            base-color="border-tertiary"
            bg-color="secondary"
            color="primary"
            :disabled="isDisabled"
            v-model="email.emailaddress"
            hide-details
            flat>
          <template #label>
            <span class="sm-normal text-subtle">{{ $store.getters.translate(label) }}</span>
          </template>
          <template #append-inner>
            <v-icon @click="deleteEmailaddress(email)" color="error" icon="mdi-trash-can"/>
          </template>
        </v-text-field>
      </template>
      <v-text-field
          density="default"
          class="reg-normal text-primary mt-3"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          :disabled="isDisabled"
          v-model="new_emailaddress.emailaddress"
          hide-details
          flat>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate(label) }}</span>
        </template>
        <template #append-inner>
          <v-icon @click="add" color="primary" icon="mdi-content-save"/>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";

export default {
  props: ["modelValue", "is_submit", "email_type", "label", "isDisabled"],
  data() {
    return {
      updated_emailaddresses: [],
      new_emailaddress: {},
    };
  },
  mounted() {
    this.new_emailaddress = {
      emailaddress: "",
      active: 0,
      type: this.email_type
    };
    this.updated_emailaddresses = this.modelValue ? this.modelValue : [];
  },
  methods: {
    add() {
      if(!this.check(this.new_emailaddress.emailaddress)) {
        this.$toast.error(this.$store.getters.translate("please_submit_valid_email"));
      }
      else if (this.new_emailaddress.emailaddress !== "") {
        this.updated_emailaddresses.push(this.new_emailaddress);
        this.new_emailaddress = {
          emailaddress: "",
          active: 0,
          type: this.email_type
        };
        this.$emit('update', this.updated_emailaddresses);
      }
    },
    check(value) {
      let validator = require("email-validator");
      return validator.validate(value);
    },
    async deleteEmailaddress(row) {
      this.$confirm(this.$store.getters.translate("confirm")).then(async (res) => {
        if (res) {
          this.updated_emailaddresses = this.updated_emailaddresses.filter((record) => record.id !== row.id || record.emailaddress !== row.emailaddress);
          if (this.updated_emailaddresses.length === 0) {
            this.$emit('email_deleted');
          }
          if (row.id) {
            await helpFunctions.deleteModel(this.$toast, "emailaddresses", row.id);
            this.$emit('update', this.updated_emailaddresses);
          }
        }
      });
    },
  },
  watch: {
    modelValue: {
      handler() {
        this.updated_emailaddresses = this.modelValue ? this.modelValue : [];
      },
    },
    is_submit:function() {
      this.new_emailaddress.emailaddress = '';
    }
  },
};
</script>